import React, { useState, memo } from "react";

/**
 * Same robot avatar used in the original AISearch.js:
 * tries /images/ai-robot.png first, falls back to an inline SVG
 * if the image 404s or fails to load.
 */
const AiAvatar = memo(function AiAvatar({ size = 26 }) {
    const [imgErr, setImgErr] = useState(false);

    if (!imgErr) {
        return (
            <img
                src="/images/ai-robot.png"
                alt="AI agent"
                width={size}
                height={size}
                style={{ width: size, height: size, objectFit: "contain", display: "block" }}
                onError={() => setImgErr(true)}
            />
        );
    }

    return (
        <svg viewBox="0 0 42 42" width={size} height={size} aria-hidden="true">
            <circle cx="21" cy="21" r="21" fill="#e8f0fe" />
            <rect x="11" y="17" width="20" height="14" rx="5" fill="#1a56db" />
            <line x1="21" y1="17" x2="21" y2="12" stroke="#1a56db" strokeWidth="2.5" strokeLinecap="round" />
            <circle cx="21" cy="10" r="2.5" fill="#1a56db" />
            <circle cx="16.5" cy="23" r="2" fill="white" />
            <circle cx="25.5" cy="23" r="2" fill="white" />
            <rect x="16" y="27" width="10" height="2.5" rx="1.25" fill="white" />
        </svg>
    );
});

export default AiAvatar;